<template>
    <div style="padding-top: 65px;height: 100vh">

        <el-row style="height: 100vh">
            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" class="border"  style="background-color:rgb(230,230,219);z-index: 888;">


                        <el-carousel class="carousel">
                            <el-carousel-item v-for="item in list" :key="item">
                                <img :src="item.url" alt="">
                            </el-carousel-item>
                        </el-carousel>



            </el-col>
            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16" class="border" style="padding: 20px;overflow: scroll">
                <el-form ref="form" :model="form"
 :rules="rules">

                    <div>
                        <el-row>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="A" prop="a">
                                    <el-input  type="number" v-model="form.a" disabled="disabled" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="B" prop="b">
                                    <el-input   type="number" v-model="form.b" disabled="disabled" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="C" prop="c">
                                    <el-input   type="number" v-model="form.c" disabled="disabled" :placeholder="placeholders[0]" />
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="D" prop="d">
                                    <el-input  type="number" v-model="form.d" disabled="disabled" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="E" prop="e">
                                    <el-input  type="number" v-model="form.e" disabled="disabled" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="F" prop="f">
                                    <el-input  type="number" v-model="form.f" disabled="disabled" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>

                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R1" prop="g">
                                    <el-input  type="number" v-model="form.g" model-value="0" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="R2" prop="h">
                                    <el-input  type="number"  v-model="form.h" model-value="0" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>
                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="T" prop="i">
                                    <el-input  type="number"  v-model="form.i" model-value="0" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>

                            <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8">
                                <el-form-item label="Z" prop="j">
                                    <el-input  type="number"  v-model="form.j" model-value="0" :placeholder="placeholders[0]"/>
                                </el-form-item>
                            </el-col>


                        </el-row>
                    </div>
<!--                    公差选择-->

                            <el-form-item  :label="labels[0]">
                                <el-select v-model="form.ee" :placeholder="placeholders[1]">
                                    <el-option  :label="labels[1]" :value="0"></el-option>
                                    <el-option  :label="labels[2]" :value="1"></el-option>
                                    <el-option  :label="labels[3]" :value="2"></el-option>
                                </el-select>
                            </el-form-item>

<!--                    公差-->
                    <div v-if="gongcha">
                        <el-row>
                            <el-col :span="8">
                                <el-form-item label="A+" prop="k">
                                    <el-input  type="number"  v-model="form.k" :placeholder="placeholders[2]" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="A-" prop="l">
                                    <el-input  type="number"  v-model="form.l" :placeholder="placeholders[3]" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="B+" prop="m">
                                    <el-input  type="text"  v-model="form.m" :placeholder="placeholders[2]" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="B-" prop="n">
                                    <el-input  type="number"  v-model="form.n" :placeholder="placeholders[3]" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="C+" prop="o">
                                    <el-input  type="number"  v-model="form.o" :placeholder="placeholders[2]" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8"  :offset="4">
                                <el-form-item label="C-" prop="p">
                                    <el-input  type="number"  v-model="form.p" :placeholder="placeholders[3]" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="D+" prop="q">
                                    <el-input  type="number"  v-model="form.q" :placeholder="placeholders[2]" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="D-" prop="r">
                                    <el-input  type="number"  v-model="form.r" :placeholder="placeholders[3]" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="E+" prop="s">
                                    <el-input  type="number"  v-model="form.s" :placeholder="placeholders[2]" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="E-" prop="t">
                                    <el-input  type="number"  v-model="form.t" :placeholder="placeholders[3]" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="8">
                                <el-form-item label="F+" prop="u">
                                    <el-input  type="number"  v-model="form.u" :placeholder="placeholders[2]" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" :offset="4">
                                <el-form-item label="F-" prop="v">
                                    <el-input  type="number"  v-model="form.v" :placeholder="placeholders[3]" />
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <el-form-item  :label="labels[4]">
                        <el-select v-model="form.gg" :placeholder="placeholders[4]">
                            <el-option  :label="labels[5]" :value="0"></el-option>
                            <el-option  :label="labels[6]" :value="1"></el-option>

                        </el-select>
                    </el-form-item>


                    <el-row v-if="qi">
                        <el-col :span="12" >
                            <div class="max">
                            <el-form-item  :label="labels[7]" prop="hh">
                                <el-input  type="number"  v-model="form.hh" :placeholder="placeholders[5]" />
                            </el-form-item>
                            </div>
                        </el-col>

                    </el-row>

                    <div>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item  :label="labels[8]" prop="x">
                                    <el-input  v-model.trim="form.x" :placeholder="placeholders[6]" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item  :label="labels[9]" prop="y">
                                    <el-input  v-model.trim="form.y" :placeholder="placeholders[7]" />
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item  :label="labels[10]" prop="z">
                                    <el-input  v-model.trim="form.z" :placeholder="placeholders[8]" />
                                </el-form-item>
                            </el-col>
<!--                            <el-col :span="12">-->
<!--                                <el-form-item  :label="labels[11]" prop="aa">-->
<!--                                    <el-input  v-model.trim="form.aa" :placeholder="placeholders[9]" />-->
<!--                                </el-form-item>-->
<!--                            </el-col>-->

                            <el-col :span="12">

                                <el-form-item

                                         :label="labels[12]"
                                        prop="bb"
                                        :rules="[{ required: true, message: '请输入邮箱地址', trigger: 'blur' },{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }]"
                                >
                                    <el-input  v-model.trim="form.bb" :placeholder="placeholders[10]" />
                                </el-form-item>
                            </el-col>

                        </el-row>


                    </div>

                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" :loading=loading>{{buttons[0]}}</el-button>
                        <el-button type="danger" @click="link()" :loading=loading>{{buttons[1]}}</el-button>

                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>


    </div>


</template>

<script>
    import request from "@/utils/request";
    export default {
        name: "EE",
        metaInfo: {
            title: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|南京恒创磁电有限公司 - Powered by MeCMS', // set a title
            meta: [{
                // 设置meta信息
                name: '大功率铁氧体磁芯|大功率磁芯|软磁铁氧体磁芯|锰锌铁氧体磁芯|大尺寸磁芯|X光磁芯|高压变压器磁芯|微波铁氧体',
                content: '大功率磁芯,南京恒创磁电专业生产各种高品质大磁芯，大功率铁氧体磁芯，软磁铁氧体磁芯，锰锌铁氧体磁芯，大尺寸磁芯，X光磁芯，高压变压器磁芯，电话:18913981759'
            }]
        },
        data(){
            var check=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<=0){
                        tip = "值必须大于0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {

                    let tip = "";

                    if (value * 1 === 0||value * 1<0) {
                        tip = "值必须大于0"
                    }else{

                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                }

            }
            var check2=(rule, value, callback) =>{
                if (value) {
                    let tip = "";
                    if (value* 1<0){
                        tip = "值必须大于等于0"
                    }

                    if (tip) {
                        callback(new Error(tip));
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }

            }
            return{
                list:[{
                    url:require("../../../assets/EE.png")
                }],
                lists:[],
                gongcha:false,
                qi:false,
                loading:false,
                placeholders:["请输入数据(单位：mm)","请选择公差","请输入正公差值(单位：mm)","请输入负公差值(单位：mm)","请选择有无气隙",
                "请输入气隙值","请输入产品名","请输入材料名称","请输入公司名","请输入客户名","请输入邮箱地址"],
                labels:["公差","无公差","标准公差","自定义公差","气隙","无气隙","自定义气隙","气隙值(单体)","产品名","材料名称",
                    "公司名","客户名","接收图纸邮箱"],
                buttons:["提交","返回"],

                form: {
                    ee:0,
                    gg:0,
                    language:0,
                    y:"H40",
                    g:0,
                    h:0,
                    i:0,
                    j:0






                },
                sizeData:[],
                rules:{
                    a:[
                        { required: true, message: '数据A是必须数据', trigger: 'blur' },

                        {validator: check,trigger: 'blur'}

                    ],
                    b:[
                        { required: true, message: '数据B是必须数据', trigger: 'blur' },
                        {validator: check,trigger: 'blur'}],
                    c:[
                        { required: true, message: '数据C是必须数据', trigger: 'blur' },
                        {validator: check,trigger: 'blur'}

                    ],
                    d:[
                        { required: true, message: '数据D是必须数据', trigger: 'blur' },
                        {validator: check,trigger: 'blur'}
                    ],
                    e:[
                        { required: true, message: '数据E是必须数据', trigger: 'blur' },
                        {validator: check,trigger: 'blur'}
                    ],
                    f:[
                        { required: true, message: '数据F是必须数据', trigger: 'blur' },
                        {validator: check,trigger: 'blur'}
                    ],
                    g:[
                        { required: true, message: '圆角1是必须数据', trigger: 'blur' },
                        {validator: check2,trigger: 'blur'}
                    ],
                    h:[
                        { required: true, message: '圆角2是必须数据', trigger: 'blur' },
                        {validator: check2,trigger: 'blur'}
                    ],
                    i:[
                        { required: true, message: '倒角是必须数据', trigger: 'blur' },

                    ],
                    j:[
                        { required: true, message: '倒角角度是必须数据', trigger: 'blur' },

                    ],

                    x:[
                        { required: true, message: '产品名是必须数据', trigger: 'blur' },
                    ],
                    y:[
                        { required: true, message: '材料名称是必须数据', trigger: 'blur' },

                    ],
                    z:[
                        { required: true, message: '公司名是必须数据', trigger: 'blur' },

                    ],
                    aa:[
                        { required: true, message: '客户名是必须数据', trigger: 'blur' },

                    ],
                    k:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    l:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    m:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    n:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    o:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    p:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    q:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    r:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    s:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    t:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    u:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                    v:[
                        { required: true, message: '公差是必须值，没有公差请填写0', trigger: 'blur' },

                    ],
                //    气隙
                    hh:[
                        { required: true, message: '气隙是必须值，没有气隙请填写0', trigger: 'blur' },


                        {validator: function (rule, value, callback) {

                                if (value) {
                                    let tip = "";
                                    if (value* 1<0){
                                        tip = "气隙值不能为负数"
                                    }

                                    if (tip) {
                                        callback(new Error(tip));
                                    } else {
                                        callback();
                                    }
                                }else{
                                    callback();
                                }


                            },trigger: 'blur'}
                    ]


                }

            }
        },
        watch:{
            form:{//深度监听，可监听到对象、数组的变化
                handler(val){
                    if(val.ee!=2){
                        this.gongcha=false
                    }else{
                        this.gongcha=true
                    }

                    if(val.gg==0){
                        this.qi=false
                    }else{
                        this.qi=true
                    }

                },
                deep:true //true 深度监听
            }


        }
        ,methods: {

            link() {
                this.$router.go(-1)
            },
            onSubmit() {

                this.$refs['form'].validate((valid) => {
                    if (valid) {


                        this.form.zz = "127.0.0.1"
                        this.loading = true;
                        request.post("http://www.magdraw.com/api/charting/addEE", this.form).then(res => {


                            if (res.code == '0') {
                                this.loading = false;
                                this.$message({
                                    type: "success",
                                    message: "新增成功"
                                })

                                // this.load() //刷新表格
                                // this.dialogVisible=false //关闭弹窗
                            } else {
                                this.loading = false;
                                this.$message({
                                    type: "error",
                                    message: res.msg
                                })
                            }

                        })
                        // }


                    } else {

                    }

                })
            },
            replace: function (input) {
                let that=this;
                if (input.indexOf("±") != -1) {
                    that.sizeData=[];
                    that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[0],
                        input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[1],
                        input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("±")[1])
                   return that.sizeData;
                } else if (input.indexOf("+") != -1) {


                        if (input.indexOf("-")!=-1){


                            that.sizeData=[];
                            that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[0].split("-")[0],
                                input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[1],
                                input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[0])

                        }else {

                            that.sizeData=[];
                            that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[0].split("-")[0],
                                input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("+")[1],
                                0)



                        }


                    return that.sizeData
                } else if (input.indexOf("-") != -1) {

                    that.sizeData=[];
                    if (input.indexOf("+")!=-1) {
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[0].split("+")[0],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[1],
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[0])
                    }else{
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[0].split("+")[0],
                            0,
                            input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "").split("-")[1].split("+")[0])

                    }
                    return that.sizeData
                } else {
                    that.sizeData=[];
                    if (input.indexOf("MAX") != -1||input.indexOf("max") != -1){
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", ""),
                            parseFloat(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "")*0.03).toFixed(2),0)
                    }else if (input.indexOf("MIN") != -1||input.indexOf("min") != -1){
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", ""),
                            parseFloat(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "")*0.03).toFixed(2),0)
                    }else {
                        that.sizeData.push(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", ""),
                            parseFloat(input.replace(/\s*/g, "").replaceAll("min", "").replaceAll("MIN", "").replaceAll("MAX", "").replaceAll("\\(", "").replaceAll("\\)", "")*0.03).toFixed(2),0)
                    }


                    return that.sizeData

                }
            }
        },
        mounted(){
            let that=this;
            this.sn=this.$route.query.sn
            request.get("/product/selectOne/"+this.sn).then(res =>{

                var obj2=JSON.parse(res.data.defined)
                obj2.name=res.data.name

                that.form.x=obj2.name
                let sizeA=that.replace(obj2.A)
                let sizeB=that.replace(obj2.B)
                let sizeC=that.replace(obj2.C)
                let sizeD=that.replace(obj2.D)
                let sizeE=that.replace(obj2.E)
                let sizeF=that.replace(obj2.F)
                that.form.a=sizeA[0]
                that.form.k=sizeA[1]
                that.form.l=sizeA[2]
                that.form.b=sizeB[0]
                that.form.m=sizeB[1]
                that.form.n=sizeB[2]
                that.form.c=sizeC[0]
                that.form.o=sizeC[1]
                that.form.p=sizeC[2]
                that.form.d=sizeD[0]
                that.form.q=sizeD[1]
                that.form.r=sizeD[2]
                that.form.e=sizeE[0]
                that.form.s=sizeE[1]
                that.form.t=sizeE[2]
                that.form.f=sizeF[0]
                that.form.u=sizeF[1]
                that.form.v=sizeF[2]
              if (that.form.a<40){
                that.form.g=0.5
                that.form.h=0.2
                that.form.i=0.3
                that.form.j=45
              }
              else if (that.form.a>=40&&that.form.a<55){
                that.form.g=1
                that.form.h=0.2
                that.form.i=0.5
                that.form.j=45
              }
              else {
                that.form.g=2
                that.form.h=0.5
                that.form.i=1
                that.form.j=45
              }

            }).catch((res)=>{
            })

        },



    }

</script>

<style lang="less" scoped>
    i:hover{
        cursor: pointer;
        color: #db261d;
    }



    div::-webkit-scrollbar {
        display: none;
    }
    /deep/
    input::-webkit-inner-spin-button {
        -webkit-appearance: none !important;
    }

    .max .el-form-item__label{
        line-height: 20px !important;
    }
    .carousel{

        margin-top: 20vh;
        text-align: center;
        img{
            height: 100%;
        }
    }

    @media screen and (max-width:768px){
        .carousel{

            margin: 0;
            padding: 0;

        }
    }
</style>